import React from 'react';
import { motion } from 'framer-motion';
import { Smartphone, ShieldCheck, Zap, HeartHandshake } from 'lucide-react';

const TechPillars = ({ isDark, lang }) => {
  const pillars = [
    {
      icon: Smartphone,
      stat: "Mobile-First",
      title: lang === 'es' ? "Rendimiento Nativo" : "Native Performance",
      desc: lang === 'es' 
        ? "Desarrollo optimizado para bajo consumo de batería y fluidez visual en cualquier gama de dispositivo."
        : "Engineered for minimal battery drain and fluid interfaces across all mobile tiers."
    },
    {
      icon: ShieldCheck,
      stat: "Ética & Privacidad",
      title: lang === 'es' ? "Protección del Usuario" : "User First Privacy",
      desc: lang === 'es'
        ? "Reportes anónimos y blindaje legal integral. La tecnología debe cuidar a quien la utiliza, no vigilarlo."
        : "Anonymous reporting and legal compliance. Software built to protect users, not monitor them."
    },
    {
      icon: Zap,
      stat: "Cero Burocracia",
      title: lang === 'es' ? "Respuestas Inmediatas" : "Instant Responses",
      desc: lang === 'es'
        ? "Arquitecturas cloud en tiempo real para alertar de riesgos, canalizar pedidos o validar referencias en minutos."
        : "Real-time cloud pipelines delivering risk alerts, local orders, or hiring checks in minutes."
    },
    {
      icon: HeartHandshake,
      stat: "Comunidad",
      title: lang === 'es' ? "Apoyo sin Reemplazo" : "Empower, Don't Replace",
      desc: lang === 'es'
        ? "Herramientas concebidas para empoderar al comerciante y al trabajador, no para sustituir su criterio."
        : "Tools crafted to empower merchants and workers, never to automate away human decisions."
    }
  ];

  return (
    <section className="py-20 px-6">
      <div className="container mx-auto max-w-6xl">
        
        {/* Encabezado sin rodeos */}
        <div className="text-left mb-12">
          <span className="text-[10px] font-black uppercase tracking-[0.4em] text-blue-500 block mb-2">
            {lang === 'es' ? 'CRITERIO DE INGENIERÍA' : 'ENGINEERING STANDARD'}
          </span>
          <h2 className="text-3xl sm:text-4xl font-black tracking-tight">
            {lang === 'es' ? 'Cómo Construimos Nuestras Soluciones' : 'How We Build Our Software'}
          </h2>
        </div>

        {/* 4 Pilares de valor técnico y humano */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {pillars.map((item, idx) => {
            const Icon = item.icon;
            return (
              <motion.div
                key={idx}
                whileHover={{ y: -4 }}
                className={`p-7 rounded-[2rem] border text-left flex flex-col justify-between transition-all ${
                  isDark 
                    ? 'bg-slate-900/30 border-white/5 hover:border-blue-500/30 hover:bg-slate-900/60' 
                    : 'bg-white border-slate-200 hover:border-blue-500/30 shadow-sm'
                }`}
              >
                <div>
                  <div className="flex items-center justify-between mb-6">
                    <div className="p-3 rounded-2xl bg-blue-500/10 text-blue-400 border border-blue-500/20">
                      <Icon size={20} />
                    </div>
                    <span className="text-[9px] font-black uppercase tracking-wider text-blue-500">
                      {item.stat}
                    </span>
                  </div>
                  <h3 className="text-lg font-black mb-2">{item.title}</h3>
                  <p className="text-xs font-bold opacity-60 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default TechPillars;